// En FireworksCanvas.jsx
import Fireworks from '@fireworks-js/react';
import React, { useEffect, useRef } from 'react';
import './index.css'


function FireworksCanvas({setup}) {
    // ... (el resto del código es correcto y no necesita cambios)
    const fireworkRef = useRef(null);



    return <div className='container-firework-canvas'   >
        <Fireworks 
        options={setup}
        ref={fireworkRef} />

    </div>;
}

export default FireworksCanvas;